import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-hazards-container',
  templateUrl: './hazards-container.component.html',
  styleUrls: ['./hazards-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HazardsContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
